/* eslint-disable @typescript-eslint/no-explicit-any */
import { get, find, flow } from 'lodash';
import scaleSize from 'utils/scale-size';

type SizeType = { width: number; height: number };

export const getImageUrl = (item = {} as any): string => {
  // todo: discuss
  return (
    get(item.pictures, [0, 'url']) ||
    get(find(item.resources, { type: 'picture' }), ['url']) ||
    get(item.picture_urls, ['2x1']) ||
    item.thumbnail_url
  );
};

export const getImageUrlByType = (item = {} as any, type = ''): string => {
  return get(
    find(item.resources, { type: 'picture', category: type }),
    'url',
    find(item.resources, { type: 'picture' }).url,
  );
};

export interface IAddResizeParams {
  (size: SizeType): (url: string) => string;
}

export const addResizeParams: IAddResizeParams = ({ width, height }) => (url) => {
  if (!url) return '';
  const divider = url.includes('?') ? '&' : '?';
  return `${url}${divider}img.crop=${Math.round(scaleSize(width) / 1.75)}x${Math.round(
    scaleSize(height) / 1.75,
  )}`;
};

export interface IGetImageUrlWithResizer {
  (item: any, size: SizeType): string;
}
export const getImageUrlWithResizer: IGetImageUrlWithResizer = (item, size) => {
  return flow(getImageUrl, addResizeParams(size))(item);
};

export interface IGetImageUrlByTypeWithResizer {
  (item: any, type: string, size: SizeType): string;
}
export const getImageUrlByTypeWithResizer: IGetImageUrlByTypeWithResizer = (item, type, size) => {
  return flow(getImageUrlByType, addResizeParams(size))(item, type);
};
